<template>
  <b-modal
    id="modal-multi-3"
    size="sm"
    title="RESPALDOS VOCALIAS "
    ok-only
    ok-title="Accept"
    v-model="$store.state.someVariables.showRespaldos"
  >
    <b-card-text class="my-1">
      Los siguientes documentos son el resultado de los partidos que se cerró
      sesión en la tablet o que se suspendieron por algún motivo.
      <br />
      Estos archivos son temporales y serán eliminados cuando PLAYGOL lo
      requiera
    </b-card-text>
    <div
      @click="openVocalia(item)"
      style="text-decoration:underline;margin-top:8px;cursor:pointer"
      v-for="(item, index) in listRespaldos"
      :key="item.id"
    >
      {{ index + 1 }} - {{ item.file_name }}
    </div>
    <template #modal-footer>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        class="float-right mr-1"
        @click="close"
      >
        Cerrar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BCardText,
  BButton,
  // BSpinner,
  // xxx,
  // xxxx,
  // sss,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
// import { ref } from '@vue/composition-api'
// import apiCall from '../../utils/apiCall'
import {
  // URL,
  URL_PDF,
  //   USER,
  //   ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'

export default {
  components: {
    BModal,
    BCardText,
    BButton,
  },
  directives: {
    // 'b-popover': VBPopover,
    // heightFade,
    Ripple,
  },
  props: {
    listRespaldos: Array,
  },
  setup() {
    function close() {
      store.commit('someVariables/UPDATE_SHOW_RESPALDOS', false)
    }
    function openVocalia(item) {
      window.open(
        `${URL_PDF}pdfVocaliaSuspendido/${item.file_name}?v=${Math.random() *
          100}`,
        // eslint-disable-next-line
        '_blank'
      )
    }
    return {
      close,
      openVocalia,
    }
  },
}
</script>
